import React, { useState } from 'react';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from "primereact/button";
import { MatchService } from '../service/matchService';
import { useCookies } from 'react-cookie';
import { v4 as uuid } from 'uuid';
import { capitalizeName, formatEdge, formatMoney, formatPct } from '../utils/format';

// Saves one outcome of a match to the visitor's picks (kept on the server under their cookie).
export function PopupForm({ match, onDone }) {
  const [amount, setAmount] = useState(10);
  const [odds, setOdds] = useState(match.Odds || null);
  const [saving, setSaving] = useState(false);
  const [userCookie, setUserCookie] = useCookies(['user']);
  const payout = (odds || 0) * (amount || 0);
  const edge = match.prob !== null && match.prob !== undefined && odds ? match.prob * odds - 1 : null;

  const handleFormSubmit = (e) => {
    e.preventDefault();
    let userCook = userCookie.UserToken;
    if (!userCook) {
      userCook = uuid();
      setUserCookie('UserToken', userCook, { path: '/' });
    }

    const userPred = {"ResultValue": match.ResultValue, "Odds": odds, "Amount": amount, "PotentialPayout": payout,
                        "ResultPicked": match.Result,
                        "HomeTeamCode": match.HomeTeamCode, "AwayTeamCode": match.AwayTeamCode,
                        "HomeImagePath": match.HomeTeamImagePath, "AwayImagePath": match.AwayTeamImagePath,
                        "LeagueImagePath": match.CountryImagePath, "MatchId": match.PredId,
                        "MatchTime": match.MatchTimeRaw, "League": match.League,
                        "UserCookie": userCook, "PredId": -1};
    setSaving(true);
    MatchService.submitUserPred(userPred)
      .then(() => onDone(true, match))
      .catch(() => onDone(false, match))
      .finally(() => setSaving(false));
  };

  return (
    <form onSubmit={handleFormSubmit} className="pick-form">
      <div className="pick-summary">
        <span className="pick-fixture">{capitalizeName(match.HomeTeamCode)} v {capitalizeName(match.AwayTeamCode)}</span>
        <span className="pick-selection">
          <i className="pi pi-check-circle" aria-hidden="true" /> {match.key === 'D' ? 'Draw' : capitalizeName(match.Result)}
        </span>
        <span className="pick-meta">Win chance {formatPct(match.prob)} · edge at these odds {formatEdge(edge)}</span>
      </div>
      <div className="pick-fields">
        <label htmlFor="pick-amount">Stake
          <InputNumber inputId="pick-amount" value={amount} onValueChange={(e) => setAmount(e.value)} min={0}
            minFractionDigits={0} maxFractionDigits={2} autoFocus />
        </label>
        <label htmlFor="pick-odds">Odds
          <InputNumber inputId="pick-odds" value={odds} onValueChange={(e) => setOdds(e.value)} min={1}
            minFractionDigits={2} maxFractionDigits={2} />
        </label>
      </div>
      <p className="pick-payout">Potential return <strong>{formatMoney(payout)}</strong></p>
      <Button label="Save pick" type="submit" icon="pi pi-check" loading={saving} disabled={!amount || !odds}
        className="w-full" />
      <p className="pick-note">
        Saved picks appear under My picks. Bet Copa Verde does not take bets or pay out; picks are for tracking only.
      </p>
    </form>
  );
}
